export default "__VITE_ASSET__yLj$zS6M__"